import React, { FC } from 'react';
import TitleLink from '../TitleLink';
import { NewsItem } from '../NewsList/Item';
import { Container } from '../NewsList/Container';
import { useRequest } from '../../hooks/useRequest';
import { getPositionNewsList, NewsCenterItem } from '../../api/newsApi';

interface Props {
  lanType: string;
  linkUrl: string;
  titleText: string;
  moreText: string;
  newsLimit: number;
  newsPositionNo: string;
  description?: string;
}

const NewsGroup: FC<Props> = (props: Props) => {
  const { lanType, newsPositionNo: positionNo, linkUrl, newsLimit: limit, titleText, moreText, description } = props;

  const { res: newsData = [] } = useRequest<any, NewsCenterItem[]>(getPositionNewsList, {
    params: { lanType, positionNo, limit },
  });

  return (
    <section>
      <div className="bg-white-homebg pt-[42px] md:pt-[60px]">
        <div className="w-full bg-white-homebg">
          <div className="mx-5 lg:max-w-screen-xl lg:pt-0 l:mx-auto">
            <TitleLink textVal={titleText} linkVal={moreText} linkUrl={linkUrl} linkOut />

            {/* 新增：可选描述文字渲染 */}
            {description && (
              <div className="pt-[11px] text-justify text-[12px] md:pt-[8px] md:text-[16px]">
                <p className="text-[rgba(0,0,0,0.6)] opacity-75 md:text-[#111]">{description}</p>
              </div>
            )}

            <div className="pt-[20px]">
              <Container>
                {newsData.map((_, index) => (
                  <NewsItem newsItemData={_} key={_.newsNo} position={3 + index} />
                ))}
              </Container>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsGroup;
